"use strict";
/**
 * The primary market picker's filter: a type chip and a free-text term.
 * Pure — the state behind it lives in `services/primary-market-filter.ts`.
 *
 * The filter narrows what the market list shows and what ‹ › step through. It
 * never picks a market by itself: the market being traded changes only on an
 * explicit pick or arrow press (the armed-button invariant, GOTCHAS §3).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_FILTER = void 0;
exports.matchesFilter = matchesFilter;
exports.filterMarkets = filterMarkets;
exports.hasCategory = hasCategory;
exports.adjacentFilteredMarketId = adjacentFilteredMarketId;
const market_categories_1 = require("./market-categories");
const market_label_1 = require("./market-label");
exports.NO_FILTER = { category: null, text: "" };
/** Does this market pass the chip and the text term (any part of its names, any case)? */
function matchesFilter(market, filter) {
    if (filter.category && (0, market_categories_1.categoryKeyForMarket)(market) !== filter.category)
        return false;
    const term = filter.text.trim().toLowerCase();
    if (!term)
        return true;
    return [(0, market_label_1.marketLabel)(market), market.title, market.yesSubtitle, market.noSubtitle, market.id].some((name) => name?.toLowerCase().includes(term));
}
function filterMarkets(markets, filter) {
    return markets.filter((m) => matchesFilter(m, filter));
}
/** Does any of these markets carry this type? */
function hasCategory(markets, category) {
    return markets.some((m) => (0, market_categories_1.categoryKeyForMarket)(m) === category);
}
/**
 * The market ‹ or › moves to, within the filter, wrapping around. From a
 * market the filter hides, › goes to the first match and ‹ to the last. Null
 * when there is nowhere else to go.
 */
function adjacentFilteredMarketId(markets, filter, selectedId, direction) {
    const shown = filterMarkets(markets, filter);
    if (shown.length === 0)
        return null;
    const at = shown.findIndex((m) => m.id === selectedId);
    if (at === -1)
        return (direction === "next" ? shown[0] : shown[shown.length - 1]).id;
    if (shown.length < 2)
        return null;
    const step = direction === "next" ? 1 : -1;
    return shown[(at + step + shown.length) % shown.length].id;
}
